const l = { isRefresherDisabled: !0 };
let o, s;
function d(t) {
  let e;
  return () => (e || (e = t().catch((n) => {
    throw e = void 0, n;
  })), e);
}
const c = d(() => import("@ledgerhq/device-management-kit")), v = d(() => import("@ledgerhq/device-transport-kit-web-hid"));
let m;
function k(t) {
  if (s !== void 0)
    throw new Error("setDmkTransportOverride: DMK already built or building — closeDmk() before changing transports");
  m = t;
}
function D() {
  if (!s) {
    let t = function(r) {
      if (s !== n)
        throw new Error(
          "connectDmkSession: closeDmk() tore down this DMK while it was still building — retry to connect over a fresh one"
        );
      return o = r.dmk, r;
    };
    const e = m, n = (async () => {
      if (e) {
        const { DeviceManagementKitBuilder: f } = await c(), w = new f().addTransport(e.transportFactory).build();
        return t({ dmk: w, transportIdentifier: e.transportIdentifier });
      }
      const [{ DeviceManagementKitBuilder: r }, { webHidTransportFactory: i, webHidIdentifier: a }] = await Promise.all([
        c(),
        v()
      ]), p = new r().addTransport(i).build();
      return t({ dmk: p, transportIdentifier: a });
    })().catch((r) => {
      throw s === n && (s = void 0), r;
    });
    s = n;
  }
  return s;
}
async function h() {
  const { dmk: t, transportIdentifier: e } = await D(), { firstValueFrom: n } = await import("rxjs"), r = await n(t.startDiscovering({ transport: e })), i = await t.connect({
    device: r,
    sessionRefresherOptions: l
  }), a = await u(t, i);
  return { dmk: t, sessionId: i, ...a };
}
async function u(t, e) {
  try {
    const { GetAppAndVersionCommand: n, isSuccessCommandResult: r } = await c(), i = await t.sendCommand({ sessionId: e, command: new n() });
    return r(i) ? { appName: i.data.name, appVersion: i.data.version } : {};
  } catch {
    return {};
  }
}
async function S(t) {
  const { firstValueFrom: e } = await import("rxjs");
  try {
    return await e(t.dmk.getDeviceSessionState({ sessionId: t.sessionId })), !0;
  } catch (n) {
    if ((n == null ? void 0 : n._tag) === "DeviceSessionNotFound") return !1;
    throw n;
  }
}
async function y(t) {
  const e = await u(t.dmk, t.sessionId);
  return { ...t, ...e };
}
async function I(t) {
  try {
    await t.dmk.disconnect({ sessionId: t.sessionId });
  } catch {
  }
}
function g() {
  o == null || o.close(), o = void 0, s = void 0;
}
export {
  h as a,
  g as c,
  I as d,
  S as i,
  y as r,
  k as s
};
//# sourceMappingURL=testing-JbFsxz79.js.map
